import React, {createContext, useContext, useReducer} from "react";


function reducer(state, action) {
    switch (action.type) {
        case "SET_SURVEY_DATA":
            return {
                ...state,
                passenger: action.passenger,
                answers: action.answers,
                questions: action.questions,
                parts: action.parts,
                card: action.card,
            }

        case "SET_ANSWER":
            return {...state, answers: {...state.answers, [action.questionId]: action.value}};

        case "SET_ACTIVE_FIELD":
            if(action.active) {
                state.activeFields.add(action.field);
            }
            else {
                state.activeFields.delete(action.field);
            }
            return state;

        case "SET_ERRORS":
            return {...state, errors: action.errors}

        case "REMOVE_ERROR":
            const errors = {...state.errors};
            delete errors[action.questionId];

            return {
                ...state, errors
            }

        case "SET_ERROR":
            const updatedErrors = {...state.errors};
            updatedErrors[action.questionId] = action.errorMessage;

            return {
                ...state, errors: updatedErrors
            }

        case "TODO":
            const newState = {...state};
            return newState;
        default:
            return state;
    }
}


const SurveyContext = createContext({});

export function useSurveyContext() {
    const context = useContext(SurveyContext);
    if (!context) {
        throw new Error('useTravelSurveyContext must be used within TravelSurveyProvider!');
    }

    return context;
}

export function SurveyProvider(props) {
    const [survey, dispatch] = useReducer(reducer, {passenger: {}, questions: {}, answers: {}, parts: {}, activeFields: new Set(), errors: {}});

    const setAnswer = (questionId, value) => {
        dispatch({
            type: "SET_ANSWER",
            questionId,
            value,
        });

        dispatch({
            type: "REMOVE_ERROR",
            questionId,
        });

    }

    const setActiveField = React.useCallback((field, active) => {
        dispatch({
            type: "SET_ACTIVE_FIELD",
            field,
            active,
        });
    }, []);


    const value = { survey, dispatch, setAnswer, setActiveField };

    return <SurveyContext.Provider value={value} {...props}/>
}